import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import IconMixin from '@rogues/shared/mixins/props/icon';

@Component
/**
 * InfoBox Props
 */
export default class Props extends Mixins(IconMixin) {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Container HTML Tag
     */
    @Prop({ default: 'div' }) tag!: string;

    /**
     * Title
     */
    @Prop() title!: string;

    /**
     * Subtitle
     */
    @Prop() subtitle!: string;

    /**
     * Link of the box
     */
    @Prop() link!: string | object;

    /**
     * Image
     */
    @Prop() img!: any;

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;
}
